import {
  COMPENSATION_VISIBILITY_KEY,
  COMPENSATION_VISIBILITY_VALUES,
} from '@app/constants/common';
import type { Nullable } from '@utils/types/Nullable';
import type { TCandidateCompensationPackage } from '@model/Candidate/Candidate.type';

export const getCandidateCompensationIsVisible = (
  compensationPackage: Nullable<TCandidateCompensationPackage>,
): boolean => {
  const compensationVisibilityStatus = localStorage.getItem(
    COMPENSATION_VISIBILITY_KEY,
  );

  if (!!compensationVisibilityStatus) {
    return (
      compensationVisibilityStatus === COMPENSATION_VISIBILITY_VALUES.VISIBLE
    );
  }

  return !!compensationPackage;
};
